import type { PropsWithChildren } from 'react';

import { FileListContainerStyled } from './styles/FileListContainerStyled'
import { type UploadCommonProps } from '../../Upload'

export interface IFileListContainerProps {
  commonProps: UploadCommonProps
}

export const FileListContainer = (
  props: PropsWithChildren<IFileListContainerProps>
) => {
  return <FileListContainerStyled {...props} />
}
